// Middleware
import AuthMiddleware from '@middleware/AuthMiddleware';

// Layouts
import LayoutConsole from '@layouts/LayoutConsole';

// Pages
import PageAccount from '@pages/account';
import PageAccountSettings from '@pages/account/PageAccountSettings';

export default {
    path: '/account',
    component: LayoutConsole,
    meta: {
        middleware: [
            AuthMiddleware,
        ],
    },
    children: [
        {
            path: '',
            name: 'account',
            component: PageAccount,
            redirect: {
                name: 'account-settings'
            },
            children: [
                {
                    path: 'general',
                    name: 'account-settings',
                    component: PageAccountSettings,
                    meta: {
                        title: 'Account'
                    }
                },
            ]
        },
    ]
}